import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private spinnerSubject = new BehaviorSubject<boolean>(true);
  public showSpinner$: Observable<boolean> = this.spinnerSubject.asObservable();

  public setShowSpinner(show: boolean) {
    this.spinnerSubject.next(show);
  }
}
